import { ModelSagres } from "@/types/model-sagres";

export class Decisao extends ModelSagres {
  TIPO_APROVACAO: number;
  assunto: string;
  cod: number;
  cod_arquivo_digital?: number;
  cod_ato_acordao: number;
  cod_ato_acordao_anterior?: number;
  cod_gestor?: number;
  cod_interessado?: number;
  cod_julgamento?: number;
  cod_lotacao?: number;
  cod_migrado?: number;
  cod_multa?: number;
  cod_parecer?: number;
  cod_processo: string;
  cod_protocolo: number;
  cod_protocolo_sij?: number;
  cod_sessao?: number;
  cod_sessao_particpante?: number;
  cod_status_processo_pauta?: number;
  cod_tipo_ocorrencia_pauta?: number;
  complemento: any;
  cripto: string;
  criptoProt: string;
  data_entrada: Date;
  data_julgamento: Date;
  data_ocorrencia?: Date;
  dt_extrato_print?: Date;
  dt_publicacao_DOE?: Date;
  ementa: any;
  espolio: boolean;
  exibir_pauta: boolean;
  item_julgado: boolean;
  julgar: boolean;
  motivo_inclusao_pauta?: any;
  observacao?: any;
  ordem: number;
  parecermp: number;
  tipo_voto_aprovacao?: any;
  ug: string;

  constructor(obj?: any) {
    super();
    if (obj) {
      this.TIPO_APROVACAO = obj.TIPO_APROVACAO;
      this.assunto = obj.assunto;
      this.cod = obj.cod;
      if (obj.cod_arquivo_digital)
        this.cod_arquivo_digital = obj.cod_arquivo_digital;
      this.cod_ato_acordao = obj.cod_ato_acordao;
      if (obj.cod_ato_acordao_anterior)
        this.cod_ato_acordao_anterior = obj.cod_ato_acordao_anterior;
      if (obj.cod_gestor) this.cod_gestor = obj.cod_gestor;
      if (obj.cod_interessado) this.cod_interessado = obj.cod_interessado;
      if (obj.cod_julgamento) this.cod_julgamento = obj.cod_julgamento;
      if (obj.cod_lotacao) this.cod_lotacao = obj.cod_lotacao;
      if (obj.cod_migrado) this.cod_migrado = obj.cod_migrado;
      if (obj.cod_multa) this.cod_multa = obj.cod_multa;
      if (obj.cod_parecer) this.cod_parecer = obj.cod_parecer;
      this.cod_processo = obj.cod_processo;
      this.cod_protocolo = obj.cod_protocolo;
      if (obj.cod_protocolo_sij) this.cod_protocolo_sij = obj.cod_protocolo_sij;
      if (obj.cod_sessao) this.cod_sessao = obj.cod_sessao;
      if (obj.cod_sessao_particpante)
        this.cod_sessao_particpante = obj.cod_sessao_particpante;
      if (obj.cod_status_processo_pauta)
        this.cod_status_processo_pauta = obj.cod_status_processo_pauta;
      if (obj.cod_tipo_ocorrencia_pauta)
        this.cod_tipo_ocorrencia_pauta = obj.cod_tipo_ocorrencia_pauta;
      this.complemento = obj.complemento;
      this.cripto = obj.cripto;
      this.criptoProt = obj.criptoProt;
      if (obj.data_entrada) this.data_entrada = new Date(obj.data_entrada);
      if (obj.data_julgamento)
        this.data_julgamento = new Date(obj.data_julgamento);
      if (obj.data_ocorrencia)
        this.data_ocorrencia = new Date(obj.data_ocorrencia);
      if (obj.dt_extrato_print)
        this.dt_extrato_print = new Date(obj.dt_extrato_print);
      if (obj.dt_publicacao_DOE)
        this.dt_publicacao_DOE = new Date(obj.dt_publicacao_DOE);
      this.ementa = obj.ementa;
      this.espolio = obj.espolio;
      this.exibir_pauta = obj.exibir_pauta;
      this.item_julgado = obj.item_julgado;
      this.julgar = obj.julgar;
      if (obj.motivo_inclusao_pauta)
        this.motivo_inclusao_pauta = obj.motivo_inclusao_pauta;
      if (obj.observacao) this.observacao = obj.observacao;
      this.ordem = obj.ordem;
      this.parecermp = obj.parecermp;
      this.tipo_voto_aprovacao = obj.tipo_voto_aprovacao;
      this.ug = obj.ug;
    }
  }
}
